// extracted by mini-css-extract-plugin
export var center = "_5v-2";
export var clickableRow = "_5v-5";
export var expandedRow = "_5v-7";
export var hoverable = "_5v-4";
export var left = "_5v-1";
export var right = "_5v-3";
export var row = "_5v-0";
export var selectedRow = "_5v-6";
export var summaryRow = "_5v-8";